var map = {
	"./avi.png": "7d86",
	"./doc.png": "5e64",
	"./excel.png": "ce16",
	"./file.png": "b258",
	"./html.png": "210e",
	"./js.png": "c116",
	"./json.png": "5768",
	"./md.png": "1819",
	"./mp3.png": "555d",
	"./mp4.png": "6948",
	"./msg.png": "09c2",
	"./pdf.png": "7081",
	"./picture.png": "1828",
	"./powerpoint.png": "318c",
	"./shell.png": "d05d",
	"./txt.png": "a94d",
	"./word.png": "bc96"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a752";